import { all } from 'redux-saga/effects';
import formActionSaga from 'redux-form-saga';
import sessionSaga from 'state/session/saga';
import couponSaga from 'state/coupons/saga';
import toastSaga from 'state/toast/saga';
import kybSaga from 'state/kyb/saga';
import globalSaga from 'state/global/saga';
import internalToolsUserSaga from 'state/internalToolsUser/saga';
import npwpSaga from 'state/npwp/saga';
import configSaga from 'state/mokaConfig/saga';
import activationSaga from 'state/activation/saga';
import resetPhoneSaga from 'state/resetPhone/saga';
import bulkOutletUpdateExpirationSaga from 'state/bulkOutletUpdateExpiration/saga';
import accessSaga from 'state/access/saga';
import userMappingSaga from 'state/userMapping/saga';
import businessSaga from 'state/business/saga';
import discountSettingsSaga from 'state/discountSettings/saga';
import discountRuleSaga from 'state/discountRule/saga';
import bulkDeleteBusinessSaga from 'state/bulkDeleteBusiness/saga';
import changeUserEmailSaga from 'state/changeUserEmail/saga';
import billingPackageSaga from 'state/billingPackage/saga';
import additionalServiceSaga from 'state/additionalService/saga';
import hardwareCatalogueSaga from 'state/hardwareCatalogue/saga';
import restoreDeletedBusinessSaga from 'state/restoreDeletedBusiness/saga';

export default function* rootSaga() {
  yield all([
    sessionSaga(),
    couponSaga(),
    toastSaga(),
    formActionSaga(),
    internalToolsUserSaga(),
    kybSaga(),
    globalSaga(),
    npwpSaga(),
    configSaga(),
    activationSaga(),
    resetPhoneSaga(),
    bulkOutletUpdateExpirationSaga(),
    accessSaga(),
    userMappingSaga(),
    businessSaga(),
    discountSettingsSaga(),
    discountRuleSaga(),
    bulkDeleteBusinessSaga(),
    changeUserEmailSaga(),
    billingPackageSaga(),
    additionalServiceSaga(),
    hardwareCatalogueSaga(),
    restoreDeletedBusinessSaga(),
  ]);
}
